'use client';
import React from 'react';
import MapScene from '../../../components/Map/MapScene';
import OnboardingModal from '../../../components/organisms/onboardingModalWrapper';

const MapPage = () => {
    return (
        <>
            <MapScene />
            <OnboardingModal />
        </>
    );
};

export default MapPage;